// Strings for the layout and shared components (components/common.jsx, DashboardLayout).
const strings = {
  es: {
    loading: "Cargando…",
    load_error: "No se pudo cargar la información",
    retry: "Reintentar",
    confirm: "Confirmar",
    type_to_confirm: "Escribe «{text}» para confirmar",
    discard_changes_q: "¿Descartar cambios?",
    discard_changes_desc: "Tienes cambios sin guardar. Si cierras, se perderán.",
    discard: "Descartar",
    nav_operation: "Operación",
    nav_admin: "Administración",
    followups: "Seguimiento",
    team: "Equipo",
    settings: "Configuración",
    clinic_profile: "Perfil de la clínica",
    skip_to_content: "Saltar al contenido",
    main_navigation: "Navegación principal",
    open_menu: "Abrir menú",
    close_menu: "Cerrar menú",
    powered_by: "Con tecnología de",
    role_assistant: "Asistente",
    tomorrow: "Mañana",
    yesterday: "Ayer",
    remove: "Quitar",
    save_changes: "Guardar cambios",
    required_field: "Campo obligatorio",
    my_account: "Mi cuenta",
  },
  en: {
    loading: "Loading…",
    load_error: "Couldn't load this information",
    retry: "Retry",
    confirm: "Confirm",
    type_to_confirm: "Type “{text}” to confirm",
    discard_changes_q: "Discard changes?",
    discard_changes_desc: "You have unsaved changes. They'll be lost if you close.",
    discard: "Discard",
    nav_operation: "Operations",
    nav_admin: "Administration",
    followups: "Follow-up",
    team: "Team",
    settings: "Settings",
    clinic_profile: "Clinic profile",
    skip_to_content: "Skip to content",
    main_navigation: "Main navigation",
    open_menu: "Open menu",
    close_menu: "Close menu",
    powered_by: "Powered by",
    role_assistant: "Assistant",
    tomorrow: "Tomorrow",
    yesterday: "Yesterday",
    remove: "Remove",
    save_changes: "Save changes",
    required_field: "Required field",
    my_account: "My account",
  },
};

export default strings;
